import { registerTour } from '@/features/tours';
import { FEATURE_FLAGS } from '@/features/featureFlags';
import {
  attendeesStep,
  contentStep,
  headerActionsStep,
  metadataStep,
} from './steps';

export const MEETINGS_DETAIL_TOUR_ID = 'meetings.detail';

registerTour({
  id: MEETINGS_DETAIL_TOUR_ID,
  name: 'Meeting',
  version: 1,
  featureFlagKey: FEATURE_FLAGS.MEETING_MINUTES.id,
  steps: [
    {
      id: 'welcome',
      title: 'Meeting details',
      body:
        'Everything tied to this meeting — schedule, attendees, the full ' +
        'agenda, summary, decisions, and action items.',
    },
    headerActionsStep,
    metadataStep,
    attendeesStep,
    contentStep,
  ],
});
